// apps/spa/src/lib/utils.ts
// shadcn standard cn() helper. Required by every shadcn component generated in 03-01.

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
